import client from "../graphqlClient";
import { getGraphqlResult } from "../../Utilities/Functions";
import {
  GET_RECORD_ACCESS_RULES,
  GET_USER_ACCESS_DETAILS,
  ADD_NEW_ACCESS_RULE,
  UPDATE_ACCESS_RULE_BY_ID,
  REMOVE_ACCESS_RULE_BY_ID,
  GET_ALL_USER_GROUPS,
} from "./graphql";

const getUserAccessDetails = async (userEmail) => {
  const response = await client.query({
    query: GET_USER_ACCESS_DETAILS,
    fetchPolicy: "network-only",
    variables: {
      userEmail,
    },
  });

  const results = await getGraphqlResult(response, "getUserAccessDetails");
  return results;
};

const getRecordAccessRules = async (variables) => {
  const response = await client.query({
    query: GET_RECORD_ACCESS_RULES,
    fetchPolicy: "network-only",
    variables,
  });

  const results = await getGraphqlResult(response, "getRecordAccessRules");
  return results;
};

const addRecordAccessRule = async (params) => {
  const response = await client.query({
    query: ADD_NEW_ACCESS_RULE,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "addRecordAccessRule");
  return results;
};

const updateRecordAccessRule = async (params) => {
  const response = await client.query({
    query: UPDATE_ACCESS_RULE_BY_ID,
    fetchPolicy: "no-cache",
    variables: params,
  });
  const results = await getGraphqlResult(response, "updateRecordAccessRule");
  return results;
};

const removeRecordAccessRule = async (params) => {
  const response = await client.query({
    query: REMOVE_ACCESS_RULE_BY_ID,
    fetchPolicy: "no-cache",
    variables: params,
  });
};

const getAllUserGroups = async (params) => {
  const response = await client.query({
    query: GET_ALL_USER_GROUPS,
    fetchPolicy: "no-cache",
  });
  const results = await getGraphqlResult(response, "getAllUserGroups");
  return results;
};

export {
  getUserAccessDetails,
  getRecordAccessRules,
  addRecordAccessRule,
  updateRecordAccessRule,
  removeRecordAccessRule,
  getAllUserGroups,
};
